import { DatabaseService, Payment, PaymentData, PaymentRepository } from "../core";
import { DatabaseCollection } from "./config";
import { getGenericRepository } from "./generic-repository";

export function getPaymentRepository(
  databaseService: DatabaseService,
): PaymentRepository {
  return getGenericRepository<Payment, PaymentData>(
    () => DatabaseCollection.PAYMENTS,
    databaseService,
  );
}
